import React, { useContext as useContextCore } from 'react'
import type { TooltipPopOverProps } from '@ztechapps/webui.util'
import isEmpty from 'lodash/isEmpty'

export type TaskTooltipPopOverProviderProps = Omit<TooltipPopOverProps, 'tooltipBody'> & {
  children: React.ReactNode
  taskId: string
  canEdit?: boolean
}

export type TaskTooltipPopOverContextType = {
  requiredValidator: (arg: any) => void
} & Omit<TaskTooltipPopOverProviderProps, 'children'>

const context = React.createContext<TaskTooltipPopOverContextType>({} as TaskTooltipPopOverContextType)
const CoreProvider = context.Provider

export const TaskTooltipPopOverProvider = ({
  children,
  taskId,
  canEdit = true,
  placement = 'auto',
  ...props
}: TaskTooltipPopOverProviderProps) => {
  const requiredValidator = (e) => {
    if (isEmpty(e)) throw new Error('Required to have a value.')
  }

  return (
    <CoreProvider
      value={{
        ...props,
        placement,
        taskId,
        requiredValidator,
        canEdit,
      }}
    >
      {children}
    </CoreProvider>
  )
}

export const useTaskTooltipPopOverContext = () => useContextCore(context)
